import { render, staticRenderFns } from "./ExcludedPublisher.vue?vue&type=template&id=a2b89856&scoped=true"
import script from "./ExcludedPublisher.vue?vue&type=script&lang=js"
export * from "./ExcludedPublisher.vue?vue&type=script&lang=js"
import style0 from "./ExcludedPublisher.vue?vue&type=style&index=0&id=a2b89856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b89856",
  null
  
)

export default component.exports